import { matchPath } from 'react-router-dom';
import { navigation } from '@/navigation';

/** Routes that render the full-page assistant: the home page and `/tappeer-ai`. */
const FULL_PAGE_CHAT_PATHS: readonly string[] = [navigation.dashboard(), navigation.tappeerAi()];

/** Whether `pathname` shows the full-page assistant, matched like the router (any case, trailing slash). */
export function isFullPageChatPath(pathname: string): boolean {
  return FULL_PAGE_CHAT_PATHS.some(path => matchPath({ path, end: true }, pathname) !== null);
}
